export default "__VITE_ASSET__0d355133__"